<template>
    <PageHeader :title="(form.updateStatus) ? sprintf($t('pages.ecommerce.promotion.editPromotionPattern'), [data.code ?? '']) : $t('pages.ecommerce.promotion.newPromotion')" back-to="/ecommerce/promotion"/>

    <el-form :model="form.data" ref="dataForm">
        <div class="row g-6 mb-6 g-xl-9 mb-xl-9 unset-position-card">
            <div class="col-md-9">

                <div class="card mb-5">
                    <div class="card-header border-bottom-dashed align-items-center" data-bs-toggle="collapse" data-bs-target="#generalCardBody">
                        <h4 class="card-title">
                            {{ $t('pages.ecommerce.promotion.save.generalCardTitle') }}
                        </h4>
                    </div>
                    <div class="card-body px-9 pt-4 collapse show" id="generalCardBody">
                        <div class="row">

                            <div class="col-md-6 col-lg-6">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.promotion.cols.name') }}</label>
                                    <el-form-item prop="name">
                                        <el-input v-model="form.data.name" type="text"/>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.promotion.cols.code') }}</label>
                                    <el-form-item prop="code">
                                        <el-input v-model="form.data.code" type="text" :readonly="this.form.updateStatus">
                                            <template #suffix>
                                                <span class="input-action" v-if="!this.form.data.id" @click="generateCode">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path
                                                        d="M14.5 20.7259C14.6 21.2259 14.2 21.826 13.7 21.926C13.2 22.026 12.6 22.0259 12.1 22.0259C9.5 22.0259 6.9 21.0259 5 19.1259C1.4 15.5259 1.09998 9.72592 4.29998 5.82592L5.70001 7.22595C3.30001 10.3259 3.59999 14.8259 6.39999 17.7259C8.19999 19.5259 10.8 20.426 13.4 19.926C13.9 19.826 14.4 20.2259 14.5 20.7259ZM18.4 16.8259L19.8 18.2259C22.9 14.3259 22.7 8.52593 19 4.92593C16.7 2.62593 13.5 1.62594 10.3 2.12594C9.79998 2.22594 9.4 2.72595 9.5 3.22595C9.6 3.72595 10.1 4.12594 10.6 4.02594C13.1 3.62594 15.7 4.42595 17.6 6.22595C20.5 9.22595 20.7 13.7259 18.4 16.8259Z"
                                                        fill="black"/><path opacity="0.3" d="M2 3.62592H7C7.6 3.62592 8 4.02592 8 4.62592V9.62589L2 3.62592ZM16 14.4259V19.4259C16 20.0259 16.4 20.4259 17 20.4259H22L16 14.4259Z" fill="black"/></svg>
                                                </span>

                                                <span class="input-action" v-if="this.form.data.id" @click="copyCode">
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd"
                                                                                                                                                                                                                                                                                                                                                                                 d="M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z"
                                                                                                                                                                                                                                                                                                                                                                                 fill="black"/></svg>
                                                </span>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="col-md-12 col-lg-12">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.promotion.cols.description') }}</label>
                                    <el-form-item prop="description">
                                        <el-input v-model="form.data.description" type="textarea" rows="3"/>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.promotion.cols.max_usage_count') }}</label>
                                    <el-form-item prop="max_usage_count">
                                        <el-input v-model="form.data.max_usage_count" type="text"/>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="fs-6 fw-bold mb-2">
                                        {{ $t('pages.ecommerce.promotion.cols.max_usage_per_usable') }}
                                        <el-tooltip class="item ms-1" popper-class="max-w-300px" effect="dark" :content="$t('pages.ecommerce.promotion.save.maxUsableDescription')" placement="top">
                                            <span class="svg-icon svg-icon-1">
                                                <inline-svg src="/media/icons/duotune/general/gen046.svg"/>
                                            </span>
                                        </el-tooltip>
                                    </label>
                                    <el-form-item prop="max_usage_per_usable">
                                        <el-input v-model="form.data.max_usage_per_usable" type="text"/>
                                    </el-form-item>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="card mb-5">
                    <div class="card-header border-bottom-dashed align-items-center" data-bs-toggle="collapse" data-bs-target="#priceCardBody">
                        <h4 class="card-title">
                            {{ $t('pages.ecommerce.promotion.save.priceCardTitle') }}
                        </h4>
                    </div>
                    <div class="card-body px-9 pt-4 collapse show" id="priceCardBody">
                        <div class="row">

                            <div class="col-md-6 col-lg-4">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="required fs-6 fw-bold mb-2">{{ $t('common.currency') }}</label>
                                    <el-form-item>
                                        <el-select v-model="form.data.currency_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable>
                                            <el-option v-for="(currency, currencyIndex) in this.$root.currencies" :key="currencyIndex"
                                                       :value="currency.id" :label="`${currency.code} - ${currency.name}`"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-4">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.promotion.cols.discount_type') }}</label>
                                    <el-form-item>
                                        <el-select v-model="form.data.discount_type_id" class="w-100" :placeholder="$t('common.chooseSelect')" :disabled="this.form.updateStatus">
                                            <el-option :value="1" :label="$t('common.percent')"></el-option>
                                            <el-option :value="2" :label="$t('common.fixed')"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-4">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.promotion.cols.discount_value') }}</label>
                                    <el-form-item prop="discount_value" :rules="$validation.getMessage(['required'])">
                                        <el-input v-model="form.data.discount_value" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                                    </el-form-item>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="card mb-5">
                    <div class="card-header border-bottom-dashed align-items-center" data-bs-toggle="collapse" data-bs-target="#productCardBody">
                        <h4 class="card-title">
                            {{ $t('pages.ecommerce.promotion.save.productCardTitle') }}
                            <el-tooltip class="item ms-1" popper-class="max-w-300px" effect="dark" :content="$t('pages.ecommerce.promotion.save.productCardTitleDescription')" placement="top">
                                <span class="svg-icon svg-icon-1">
                                    <inline-svg src="/media/icons/duotune/general/gen046.svg"/>
                                </span>
                            </el-tooltip>
                        </h4>
                    </div>
                    <div class="card-body px-9 pt-4 collapse show" id="productCardBody">
                        <div class="row">
                            <div class="d-flex align-items-center justify-content-center flex-column w-100">
                                <el-alert
                                    :title="$t('pages.ecommerce.promotion.save.no_selected_product')"
                                    class="mb-5"
                                    type="warning"
                                    show-icon
                                    :closable="false"
                                    v-if="!form.data?.targets?.length"
                                />
                                <custom-table
                                    v-else
                                    rowKey="id"
                                    hideHeader="true"
                                    :items="form.data?.targets"
                                    :loading="false"
                                    :columns="fields.product">
                                    <template v-slot:actions="{ row: record }">
                                        <div class="d-flex justify-content-end">
                                            <a @click="deleteProduct([record.id])" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                                                <span class="svg-icon svg-icon-3">
                                                    <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                                                </span>
                                            </a>
                                        </div>
                                    </template>
                                </custom-table>

                                <div>
                                    <button class="btn btn-primary" type="button" @click="addTargets()">Yeni</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="card mb-5">
                    <div class="card-header border-bottom-dashed align-items-center" data-bs-toggle="collapse" data-bs-target="#companyCardBody">
                        <h4 class="card-title">
                            {{ $t('pages.ecommerce.promotion.save.companyCardTitle') }}
                            <el-tooltip class="item ms-1" popper-class="max-w-300px" effect="dark" :content="$t('pages.ecommerce.promotion.save.companyCardTitleDescription')" placement="top">
                                <span class="svg-icon svg-icon-1">
                                    <inline-svg src="/media/icons/duotune/general/gen046.svg"/>
                                </span>
                            </el-tooltip>
                        </h4>
                    </div>
                    <div class="card-body px-9 pt-4 collapse show" id="companyCardBody">
                        <div class="row">

                            <div class="d-flex align-items-center justify-content-center flex-column w-100">
                                <el-alert
                                    :title="$t('pages.ecommerce.promotion.save.no_selected_company')"
                                    class="mb-5"
                                    type="warning"
                                    show-icon
                                    :closable="false"
                                    v-if="!form.data?.promotion_scopes?.length"
                                />
                                <custom-table
                                    v-else
                                    rowKey="id"
                                    hideHeader="true"
                                    class="mb-5"
                                    :items="form.data?.promotion_scopes"
                                    :loading="false"
                                    :columns="fields.company">
                                    <template v-slot:actions="{ row: record }">
                                        <div class="d-flex justify-content-end">
                                            <a @click="deleteScope([record.id])" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                                                <span class="svg-icon svg-icon-3">
                                                    <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                                                </span>
                                            </a>
                                        </div>
                                    </template>
                                </custom-table>

                                <div>
                                    <button class="btn btn-primary" type="button" @click="addScope()">Yeni</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

            <div class="col-md-3">
                <div class="sticky-card">
                    <div class="card">
                        <div class="card-body">
                            <div class="fv-row mb-1 mt-3">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.promotion.cols.starts_at') }}</label>
                                <el-form-item prop="starts_at">
                                    <el-date-picker v-model="form.data.starts_at" type="datetime"
                                                    :placeholder="$t('common.chooseDate')"
                                                    valueFormat="YYYY-MM-DD hh:mm:ss"
                                                    :disabledDate="startDateDisabled"></el-date-picker>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-1 mt-3">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.promotion.cols.expires_at') }}</label>
                                <el-form-item prop="expires_at">
                                    <el-date-picker v-model="form.data.expires_at" type="datetime"
                                                    :placeholder="$t('common.chooseDate')"
                                                    valueFormat="YYYY-MM-DD hh:mm:ss"
                                                    :disabledDate="endDateDisabled"></el-date-picker>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-1 mt-3">
                                <label class="fs-6 fw-bold mb-2">{{ $t('common.status') }}</label>
                                <el-form-item prop="active" :rules="$validation.getMessage(['required'])">
                                    <el-radio-group v-model="form.data.active" text-color="#fff" fill="#0C2C55">
                                        <el-radio-button :label="$t('common.active')" :value="true"/>
                                        <el-radio-button :label="$t('common.passive')" :value="false"/>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="fv-row mt-5">
                        <el-form-item class="mb-0">
                            <button @click.prevent="onSubmit" :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary w-100" type="button">
                                <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                                <span v-if="form.loading" class="indicator-progress">
                                    {{ $t("messages.wait") }}
                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
import PageHeader from "@/components/page-header/PageHeader.vue";
import CustomTable from "@/components/custom-table/index.vue";

export default {
    name: "_id",
    components: {
        CustomTable,
        PageHeader,
    },
    data() {
        return {
            fields: {
                product: [
                    {
                        name: this.$t("pages.ecommerce.product.cols.id"),
                        key: 'id',
                    },
                    {
                        name: this.$t("pages.ecommerce.product.cols.name"),
                        key: 'targetable.name',
                    },
                    {
                        name: this.$t("common.action"),
                        scopedSlots: {customRender: "actions"}
                    }
                ],
                company: [
                    {
                        name: this.$t("pages.company.cols.id"),
                        key: 'id',
                    },
                    {
                        name: this.$t("pages.company.cols.name"),
                        key: 'scopable.name',
                    },
                    {
                        name: this.$t("common.action"),
                        scopedSlots: {customRender: "actions"}
                    }
                ]
            },
            data: {},
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {}
            },
            rules: {},
        }
    },
    computed: {
        itemID() {
            return this.$route.params.id;
        },
        save() {
            return this.$store.state.ecommerce.promotion.save.data;
        }
    },
    created() {
        this.resetForm();

        if (this.itemID && !(this.itemID > 0)) {
            this.$router.push({
                path: "/ecommerce/promotion",
            });
        }
    },
    mounted() {
        if (this.itemID && this.itemID > 0) {
            this.setCurrentPageBreadcrumbs(this.sprintf(this.$t('pages.ecommerce.promotion.editPromotion'), [this.data.code ?? ""]), []);
            this.form.updateStatus = true;
            this.loadData();
        } else {
            this.setCurrentPageBreadcrumbs(this.$t('pages.ecommerce.promotion.newPromotion'), []);
        }
    },
    watch: {
        itemID(newValue) {
            if (newValue && newValue > 0) {
                this.form.updateStatus = true;
                this.loadData(newValue);
                this.setCurrentPageBreadcrumbs(this.sprintf(this.$t('pages.ecommerce.promotion.editPromotion'), [this.data.code ?? ""]), []);
            } else {
                this.resetForm();
                this.setCurrentPageBreadcrumbs(this.$t('pages.ecommerce.promotion.newPromotion'), []);
            }
        }
    },
    methods: {
        async loadData(itemID = this.itemID) {
            this.$store.dispatch("ecommerce/promotion/show", {
                id: itemID
            }).then(() => {
                let data = this.save;
                this.form.loading = false;
                this.data = data;
                this.form.data = data;
            });
        },
        onSubmit() {
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    this.form.loading = true;

                    if (this.form.updateStatus) {
                        this.$store.dispatch('ecommerce/promotion/update', {
                            id: this.form.data.id,
                            formData: this.form.data
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    let itemID = response.data.id;
                                    this.loadData(itemID);
                                });
                            }

                            this.form.loading = false;
                        });
                    } else {
                        this.$store.dispatch('ecommerce/promotion/add', {
                            formData: this.form.data
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    let id = response.data.id;
                                    this.loadData(id);
                                    this.$router.push({
                                        path: "/ecommerce/promotion/save/" + id
                                    });
                                });
                            }

                            this.form.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        addScope() {

        },
        deleteScope(id) {
            this.eventBus.$emit('showConfirmDialog', {
                title: this.$t('btn.delete'),
                message: this.$t('messages.sureDelete'),
                confirmType: 'danger',
                onConfirm: () => {
                    // TODO: silme akisi implement edilmedi
                },
            });
        },
        addTarget() {

        },
        deleteTarget(id) {

        },
        resetForm() {
            this.form.updateStatus = false;
            this.form.data = {
                code: null,
                name: null,
                description: null,
                discount_type_id: 1,
                discount_value: null,
                currency_id: 1,
                max_usage_count: null,
                max_usage_per_usable: null,
                starts_at: null,
                expires_at: null,
                active: true,
                targets: [],
                scopes: []
            };
        },
        generateCode() {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            let code = '';

            for (let i = 0; i < 8; i++) {
                code += chars.charAt(Math.floor(Math.random() * chars.length));
            }

            this.form.data.code = `PROMO-${code}`;
        },
        copyCode() {
            navigator.clipboard.writeText(this.form.data.code);
        },
        format(price) {
            const value = Number(price)

            if (isNaN(value)) {
                return '0,00'
            }

            return value.toLocaleString('tr-TR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        },
        startDateDisabled(date) {
            return date.getTime() < Date.now()
        },
        endDateDisabled(date) {
            return (date.getTime() < Date.now()) || (date.getTime() < new Date(this.form.data.usage_start_date).getTime())
        },
    }
}
</script>

<style>
.sticky-card {
    position: sticky;
    top: 140px;
}

.input-action {
    cursor: pointer;
    color: var(--bs-gray-500, #a1a5b7);
    display: flex;
    align-items: center;
    height: 100%;
    transition: color 0.15s;
}

.input-action:hover {
    color: var(--bs-danger, #f1416c);
}

.card-body.collapse .card {
    width: 100% !important;
}

.card-body.collapse .card-body {
    padding: 0 !important;
}
</style>